import _ from "lodash";
import React, { memo, useContext } from "react";
import { NavLink, withRouter } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import CONSTANTS from "../../common/constants";
import UserActions from "./../../store/actions/userActions";
import { OidcContext } from "../OidcContext";

const Menu = memo(() => {
	const dispatch = useDispatch();

	const { isAuthorized, isAuthenticated } = useContext(OidcContext);
	const environment = useSelector(state => _.get(state, `environment.environment`, `NO VERSION FOUND`));

	return (
		<>
			<nav id="nav-first-level" className="navbar navbar-fixed-top">
				<div className="navbar-inner container">
					<div id="nav-primary">
						<ul className="float-left large-nav nav navbar-nav">
							<li className="navbar-nav-icon">
								<NavLink exact to={`${CONSTANTS.ROUTE.ROOT}`}>
									<i className="icon-home" />
								</NavLink>
							</li>
						</ul>
						<ul className="float-right large-nav nav navbar-nav">
							<li>
								<a href={`${CONSTANTS.ROUTE.ROOT}`} className="red-toyota float-right">
									{environment}
								</a>
							</li>
							{
								isAuthenticated()
									? (
										<li className="navbar-nav-icon">
											<a
												onClick={() => {
													dispatch(UserActions.logout());
												}}
											>
												<i className="fa fa-lock" aria-hidden="true" title={`Logout`} />
											</a>
										</li>
									)
									: null
							}
							<li className="navbar-nav-icon">
								<img className="padding-left-25" title={`TOYOTA`}
									src="//www.toyota-europe.com/favicon.ico" />
							</li>
						</ul>
					</div>
				</div>
			</nav>

			<nav id="nav-secondary-level" className="bar-blue">
				<ul className={`container`}>
					{
						isAuthorized()
							? (
								<>
									<li>
										<NavLink to={`${CONSTANTS.ROUTE.CUSTOMERS}`}>Customers</NavLink>
									</li>
									<li>
										<NavLink to={`${CONSTANTS.ROUTE.VEHICLES}`}>Vehicles</NavLink>
									</li>
								</>
							)
							: null
					}
				</ul>
			</nav>
		</>
	);
});
Menu.displayName = `Menu`;
export default withRouter(Menu);
